import React from 'react';

import { useAppSelector } from '../../../../store/hook';
import { DPE_QUALIF_STEPS } from './dpeQualifStep';
import DpeStep1 from './DpeStep1';
import DpeStep2 from './DpeStep2';
import DpeStep3 from './DpeStep3';

interface DpeStepsProps {
  isDpeTreated: boolean;
  area?: number;
}
function DpeSteps({ isDpeTreated = false, area }: DpeStepsProps) {
  const currentStep = useAppSelector((state) => state.dpe.currentStep);

  return (
    <div className="w-full p-4 leading-8">
      {currentStep === DPE_QUALIF_STEPS.COMPLETING_OWNER_COUNT && (<DpeStep1 isDpeTreated={isDpeTreated} area={area} />)}
      {(currentStep === DPE_QUALIF_STEPS.COMPLETING_OWNERS_DETAILS || currentStep === DPE_QUALIF_STEPS.DISPLAY_OWNERS_DETAILS) && (
        <DpeStep2 />
      )}
      {currentStep === DPE_QUALIF_STEPS.REDIRECTION_TO_DPE_OR_IDENTIFIED && (<DpeStep3 />)}
    </div>
  );
}

export default DpeSteps;
